<template>
  <div id="pdf-pages">
    <pdf-intro
      :pdfPageIndex="pdfPageIndex"
      :pdfPagesLength="getPdfPagesLength"
      :formNumber="9"
      form="Formularz 9"
    />

    <page-one
      v-if="isFirstPage"

      :pdfContent="content"
      :attachmentNumber="content.attachmentNumber"
      :attachmentName="content.attachmentName"
      :pageTitle="content.pageTitle"
      :mainTitle="content.mainTitle"

      :instituteName="content.instituteName"
      :notice="content.notice"

      :localGovermentUnit="content.localGovermentUnit"
      :localGovermentUnitOnly="content.localGovermentUnitOnly"
      :bottomInfoText="content.bottomInfoText"

      :checkboxes="content.checkboxes"
    />

    <page-shared
      v-else-if="isLastPage"
      :content="pdfPages[pdfPageIndex]"
      :page="pdfPageIndex"
      :formNumber="9"
    />

    <page-last
      v-if="!isLastPage"
      :content="pdfPages[pdfPageIndex]"
      :pdfContent="content"
      :formNumber="9"
    />

    <pdf-footnote
      v-if="isFootnote"
      :footnoteContent="getFootnote"
      :double-star="false"
    />

    <page-switcher
      :pdfPageIndex="pdfPageIndex"
      :pdfPagesLength="getPdfPagesLength"
      @pageChanged="changePage"
      @generatePdf="generatePdf"
    />

  </div>
</template>

<script>
import PageShared from '../Shared/Pdf-9,8/Page'
import PdfFootnote from '../Shared/PdfFootnote'
import PageLast from '../Shared/Pdf-9,8/PageLast'
import PdfPageSwitcher from '../Shared/PdfPageSwitch'
import PageOne from '../Shared/Pdf-9,8/PageOne'
import PdfIntro from '../Shared/PdfIntro';
import jsPdfMixin from '../../mixins/jsPdfMixin'

export default {
  name: 'Pdf9',
  data: function () {
    return {
      content: {},
      pdfPages: null,

      pdfPageIndex: -1,
      currentPdfPage: {}
    }
  },

  props: ['pdfContent'],

  mixins: [jsPdfMixin],

  components: {
    'page-switcher': PdfPageSwitcher,
    'page-shared': PageShared,
    'page-one': PageOne,
    'page-last': PageLast,
    'pdf-intro': PdfIntro,
    'pdf-footnote': PdfFootnote
  },

  created: function () {
    this.content = this.$store.getters['pdf/pdfContent']
    this.pdfPageIndex = this.$store.getters['pdf/pageIndex']

    if (this.content == null) {
      this.content = this.pdfContent
    }

    if (this.content.attachmentNumber != 'Załącznik nr 9') {
      this.content = this.pdfContent
    }

    this.pdfPages = this.content.content.pages
    this.currentPdfPage = this.content[this.pdfPageIndex]

    this.initializeDoc()
  },

  computed: {
    getPdfPagesLength () {
      return this.pdfPages.length
    },

    isFirstPage () {
      return this.pdfPageIndex > -1
        ? false
        : true
    },

    isLastPage () {
      return this.pdfPageIndex >= this.pdfPages.length - 1
        ? false
        : true
    },

    isFootnote () {
      if (this.isFirstPage) {
        return this.content.footnote != null
          ? true
          : false
      }
      return this.pdfPages[this.pdfPageIndex].footnote != null
        ? true
        : false
    },

    getFootnote () {
      if (!this.isFootnote) {
        return
      }

      if (this.isFirstPage) {
        return this.content.footnote
      }

      return this.pdfPages[this.pdfPageIndex].footnote
    }
  },

  watch: {
    pdfPageIndex: function () {
      this.currentPdfPage = this.pdfPages[this.pdfPageIndex]
    }
  },

  methods: {
    changePage (index) {
      // means thats we were on the first page
      if ((index - 1) == -1 ) {
        this.pdfPageIndex = index
        this.initializeDoc()
        this.createFirstPage()
        return
      }
      this.createPdfTable(this.pdfPageIndex)
      this.pdfPageIndex = index
    },

    generatePdf() {
      this.savePdfPage()
    }
  }
}
</script>